import { useTranslation } from "react-i18next";
import { PageTitle, Card, Notice } from "../components/kit";
import { Loading, HistoryList } from "../components/common";
import { usePaged, LoadMore } from "../lib/paged";

export default function AuditLog() {
  const { t } = useTranslation();
  const pg = usePaged("/audit", {});
  return (
    <div className="mx-auto max-w-3xl">
      <PageTitle title={t("audit.title")} sub={t("audit.sub")} />
      <div className="mb-4"><Notice>{t("audit.note")}</Notice></div>
      <Card>{pg.items ? <>
        <HistoryList items={pg.items} testid="audit-list" />
        <LoadMore shown={pg.items.length} total={pg.total} onMore={pg.more} loading={pg.loading} testid="audit" />
      </> : <Loading />}</Card>
    </div>
  );
}
